import { render } from "./dappButton.vue?vue&type=template&id=70d5801f"
import script from "./dappButton.vue?vue&type=script&lang=js"
export * from "./dappButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__